import { useMutation } from "react-query";
import { api } from "utils/api";
import type { PartnerCurationPostBody } from "../types";

const postPartnerCuration = (body: PartnerCurationPostBody) =>
  api.post("/open-call/partner/vote", {
    body: JSON.stringify(body),
  });

const usePartnerCuration = () => useMutation(postPartnerCuration);

export { usePartnerCuration };
